import { render } from "./BlogArticleView.vue?vue&type=template&id=371f5458&scoped=true"
import script from "./BlogArticleView.vue?vue&type=script&lang=js"
export * from "./BlogArticleView.vue?vue&type=script&lang=js"

import "./BlogArticleView.vue?vue&type=style&index=0&id=371f5458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371f5458"]])

export default __exports__